export default __webpack_public_path__ + "static/media/picture3.e0fb16c4.png";